import * as React from "react";
import Text from "../../../../Text/index";
import createAnimatedComponent from "../createAnimatedComponent";
var AnimatedText_default = createAnimatedComponent(Text);
export {
  AnimatedText_default as default
};
//# sourceMappingURL=AnimatedText.js.map
